import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import Button from "@components/buttons/Button";

import { useRootAppStore } from "@hooks";

import { THEME_SETTINGS } from "@theme-settings";

import { WaitingPeriodPopupStateEnum } from "@utils/common/waitingPeriodPopupStateEnum";
import { WaitingPeriodPopupTypeEnum } from "@utils/common/waitingPeriodPopupTypeEnum";
import WaitingPeriodTimer from "@features/waiting-period/WaitingPeriodTimer";
import { isUserAuthenticated } from "@utils";

export default observer(function WaitingPeriodSubmitModal() {
	const { t } = useTranslation("user-account");

	const rootStore = useRootAppStore();

	const { waitingPeriodStore } = rootStore;

	useEffect(() => {
		waitingPeriodStore.onInitialize();

		return () => {
			waitingPeriodStore.onDispose();
		};
	}, []);

	if (!THEME_SETTINGS.isWaitingPeriodEnabled) {
		return null;
	}

	if (!isUserAuthenticated()) {
		waitingPeriodStore.hidePopup();
		return null;
	}

	if (
		rootStore.betSlipStore.isSlipEmpty &&
		!rootStore.betSlipStore.isOneClickBetActive
	) {
		waitingPeriodStore.hidePopup();
		return null;
	}

	if (
		waitingPeriodStore.popupType != WaitingPeriodPopupTypeEnum.SUBMIT ||
		waitingPeriodStore.popupState == WaitingPeriodPopupStateEnum.HIDDEN
	) {
		return null;
	}

	const isFloating =
		waitingPeriodStore.popupState == WaitingPeriodPopupStateEnum.MINIMIZED;

	const submitClasses = classNames("popup__footer__btn btn--med", {
		"btn--primary--inverted": waitingPeriodStore.timeLeft > 0,
		"btn--accent btn--icon": waitingPeriodStore.timeLeft <= 0,
	});

	if (isFloating) {
		return <WaitingPeriodTimer />;
	}

	if (waitingPeriodStore.popupState == WaitingPeriodPopupStateEnum.ACTIVE) {
		return (
			<div className="popup popup--above-all">
				<div className="popup__card">
					<div className="popup__header u-padd--bottom--reset">
						<div className="popup__title" />

						<Button
							type="button"
							className="btn--square btn--square--sml btn--primary--inverted popup__close"
							iconOnly
							iconClassName="u-icon--tny u-icon--minimise--reg"
							onClick={waitingPeriodStore.minimizePopup}
						/>
					</div>

					<div className="popup__body u-gap--base">
						<div className="popup__title popup__title--med popup__title--centered">
							{t("LUGAS.WAITING_PERIOD_INFO_TITLE")}
						</div>

						<WaitingPeriodTimer />

						<div className="popup__text">
							{t("LUGAS.WAITING_PERIOD_INFO_DESC")}
						</div>

						<div className="popup__text">
							{t("LUGAS.WAITING_PERIOD_INFO_FOOTER")}
						</div>
					</div>

					{!rootStore.betSlipStore.isOneClickBetActive && (
						<div className="popup__footer popup__footer--bordered">
							<Button
								type="submit"
								className={submitClasses}
								btnText={t("BET_SLIP.SUBMIT_BET")}
								iconRight
								iconClassName={
									"u-icon--sml" +
									(waitingPeriodStore.timeLeft > 0
										? " u-icon--video-pause"
										: " u-icon--arrow-right u-color--accent--text")
								}
								disabled={waitingPeriodStore.timeLeft > 0}
								onClick={waitingPeriodStore.submitSlip}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}

	return null;
});
